export default "__VITE_ASSET__83083cf0__"